import React, { memo, useState, useEffect } from 'react';

import style from './style.module.css';

/**
 * Level inout component for render custom cell.
 *
 * @param {object} params Params.
 */
const LevelInputHeaderCellComponent = ({
  api,
  defaultValue,
  displayName,
  setFilter,
  enableSorting,
  enableMenu,
  showColumnMenu,
  progressSort,
  column,
  readOnly,
}) => {
  const [sort, setSort] = useState(column.getSort());

  useEffect(() => {
    const updateSort = () => setSort(column.getSort());

    column.addEventListener('sortChanged', updateSort);

    return () => column.removeEventListener('sortChanged', updateSort);
  }, [column]);

  const handleSort = event => {
    event.stopPropagation();
    progressSort();
    setSort(column.getSort());
  };

  const handleMenu = event => {
    event.stopPropagation();
    showColumnMenu(event.target);
  };

  const handleChange = event => {
    const value = Number(event.target.value);

    setFilter(value);
    setTimeout(() => {
      api.refreshCells({ force: true });
    }, 500);
  };

  return (
    <div className={style.host} onClick={handleSort}>
      <span className={style.label}>{displayName} &gt;&nbsp;</span>
      <input
        className={style.input}
        defaultValue={defaultValue}
        max={100}
        min={1}
        onChange={handleChange}
        onClick={event => event.stopPropagation()}
        readOnly={readOnly}
        type="number"
      />
      %{enableSorting && sort === 'asc' && <span className="ag-icon ag-icon-asc" />}
      {enableSorting && sort === 'desc' && <span className="ag-icon ag-icon-desc" />}
      {enableMenu && <span className="ag-icon ag-icon-menu" onClick={handleMenu} />}
    </div>
  );
};

export const LevelInputHeaderCell = memo(LevelInputHeaderCellComponent);
